module.exports = __webpack_public_path__ + "static/img/invite-friend.0e44c046.png";